<div class="tooltip">
  <div [ngClass]="{'tooltip-container': !cssStyles}" [style]="cssStyles">
    <ng-template #simpleText>
      {{text}}
    </ng-template>
    <ng-container *ngTemplateOutlet="contentTemplate || simpleText">
    </ng-container>
  </div>
</div>